import { useParams, Link } from "react-router-dom";
import { useContext } from "react";
import DataContext from "../context/DataContext";
import { formatDate, readTime, initials } from "../utils/text";
import { getCategoryPillClass } from "../utils/categoryColor";
import { ClockIcon, ShareIcon, BookmarkIcon } from "./Icons";

export default function PostPage() {
  const { id } = useParams();
  const { items } = useContext(DataContext);

  const post = items.find((item) => item.id === id);

  if (!post) {
    return <h2 className="not-found">Post not found</h2>;
  }

  // Reuse posts already loaded in context for "related" — avoids an extra
  // network request. Falls back to nothing if only this post is loaded yet.
  const related = items.filter((item) => item.id !== id).slice(0, 2);

  const handleShare = async () => {
    const shareData = { title: post.title, url: window.location.href };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch {
        // user cancelled — no-op
      }
    } else {
      await navigator.clipboard.writeText(window.location.href);
    }
  };

  return (
    <article className="post-page">
      {post.category && (
        <span className={`pill ${getCategoryPillClass(post.category)}`}>
          {post.category}
        </span>
      )}

      <h1 className="post-title">{post.title}</h1>

      <div className="post-meta">
        <div className="post-author-avatar">
          {post.authorImage ? (
            <img src={post.authorImage} alt={post.author} />
          ) : (
            <span>{initials(post.author)}</span>
          )}
        </div>
        <span className="post-author-name">{post.author}</span>
        <span className="post-meta-dot">·</span>
        <span className="post-meta-secondary">{formatDate(post.publishedAt)}</span>
        <span className="post-meta-dot">·</span>
        <span className="post-meta-secondary">
          <ClockIcon className="inline-icon" /> {readTime(post.description)}
        </span>
        <div className="post-actions">
          <button className="icon-button" onClick={handleShare} aria-label="Share">
            <ShareIcon />
          </button>
          <button className="icon-button" aria-label="Bookmark">
            <BookmarkIcon />
          </button>
        </div>
      </div>

      <img src={post.image} alt={post.title} className="post-img" />

      <div className="post-body" dangerouslySetInnerHTML={{ __html: post.description }} />

      {post.tags && post.tags.length > 0 && (
        <div className="hashtags">
          {post.tags.map((tag, i) => (
            <span key={i} className="hashtag">{tag}</span>
          ))}
        </div>
      )}

      {related.length > 0 && (
        <div className="related-section">
          <div className="related-heading">Related articles</div>
          <div className="related-grid">
            {related.map((item) => (
              <Link to={`/post/${item.id}`} key={item.id} className="related-card">
                <img src={item.image} alt={item.title} loading="lazy" />
                <p>{item.title}</p>
              </Link>
            ))}
          </div>
        </div>
      )}
    </article>
  );
}
